import { observable } from '@trpc/server/observable';
import { transformResult } from '@trpc/server/unstable-core-do-not-import';
import { TRPCClientError } from '../TRPCClientError.mjs';
import { resolveHTTPLinkOptions, jsonHttpRequester } from './internals/httpUtils.mjs';

function httpLinkFactory(factoryOpts) {
    return (opts)=>{
        const resolvedOpts = resolveHTTPLinkOptions(opts);
        return (runtime)=>({ op  })=>observable((observer)=>{
                    const { path , input , type  } = op;
                    const { promise , cancel  } = factoryOpts.requester({
                        ...resolvedOpts,
                        runtime,
                        type,
                        path,
                        input,
                        headers () {
                            if (!opts.headers) {
                                return {};
                            }
                            if (typeof opts.headers === 'function') {
                                return opts.headers({
                                    op
                                });
                            }
                            return opts.headers;
                        }
                    });
                    let meta = undefined;
                    promise.then((res)=>{
                        meta = res.meta;
                        const transformed = transformResult(res.json, runtime.transformer);
                        if (!transformed.ok) {
                            observer.error(TRPCClientError.from(transformed.error, {
                                meta
                            }));
                            return;
                        }
                        observer.next({
                            context: res.meta,
                            result: transformed.result
                        });
                        observer.complete();
                    }).catch((cause)=>{
                        observer.error(TRPCClientError.from(cause, {
                            meta
                        }));
                    });
                    return ()=>{
                        cancel();
                    };
                });
    };
}
/**
 * @link https://trpc.io/docs/v11/client/links/httpLink
 */ const httpLink = httpLinkFactory({
    requester: jsonHttpRequester
});

export { httpLink, httpLinkFactory };
